export default {
  brand: {
    primary: '#000000',
    secondary: '#E10098',
    tertiary: '#C60086',
    quaternary: '#000000',
  },
};
